import { getENV } from '@libs/common-next';

export const gtmConfig = {
    ca: {
        gtmContainerId: getENV('NEXT_PUBLIC_GTM_CA_CONTAINER_ID'),
        gtmPreview: getENV('NEXT_PUBLIC_GTM_CA_PREVIEW'),
        gtmAuth: getENV('NEXT_PUBLIC_GTM_CA_AUTH'),
    },
    us: {
        gtmContainerId: getENV('NEXT_PUBLIC_GTM_US_CONTAINER_ID'),
        gtmPreview: getENV('NEXT_PUBLIC_GTM_US_PREVIEW'),
        gtmAuth: getENV('NEXT_PUBLIC_GTM_US_AUTH'),
    },
} as const;

export enum Events {
    VIEW_PAGE_SECTION = 'view_page_section',
    VIEW_ITEM_LIST = 'view_item_list',
}

export enum LoginEvents {
    CHECKOUT = 'Checkout',
    LOGIN_PAGE = 'Login Page',
    SIGN_IN_DRAWER = 'Login Pop-Up Window',
}
